import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {YzSelectContactsComponent} from './yz-select-contacts/yz-select-contacts.component';
import {SharedModule} from "../shared.module";
import {LoadingModule} from "../loading/loading.module";
import {YzRoleSelectContactsComponent} from './yz-role-select-contacts/yz-role-select-contacts.component';

const COMPONENTS = [
  YzSelectContactsComponent,
  YzRoleSelectContactsComponent
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS],
  imports: [SharedModule, LoadingModule],
  exports: [...COMPONENTS]
})
export class SelectContactsModule {
}
